// extracted by mini-css-extract-plugin
export default {"cls1":"zSfIHy3ZSTS3mou0PO3l","cls2":"NeP4yUvEEcIbBSZvm049 zSfIHy3ZSTS3mou0PO3l"};